var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPass1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 41.1 44.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#231916;}.cls-2{font-size:9.43px;font-family:AppleSDGothicNeo-Heavy-KSCpc-EUC-H, Apple SD Gothic Neo;}.cls-3{font-size:12.9px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\uC790\uC0B0 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uB808\\uC774\\uC5B4_2",
    "data-name": "\\uB808\\uC774\\uC5B4 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.6,4.6H24l-.7,1.9a1,1,0,0,0,.5.4h.6a1,1,0,0,0,.5-.7V5.8a1.3,1.3,0,0,0,.2-.8A1,1,0,0,0,24.6,4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.9,7.4c-.1.1-.2.2-.2.3a.4.4,0,0,0,.3.6h.5l.3-.7-.5-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.3,0,15.7,15.7l-5.4,4.5h-.2c-1.5,1.1-2.8,2-4.4,6.7S.1,41.6.1,41.7a.7.7,0,0,0,.4,1H.8a.8.8,0,0,0,.7-.5c0-.1,4.1-10.2,5.7-14.7s2.4-4.9,3.8-5.9h.2l3.4-2.8L10.8,29.2c-.2.4.1.8.5,1a.9.9,0,0,0,1-.5L19.7,9l16.9,6.2L26.6,43,16,39.2a10.6,10.6,0,0,0,3.4-3.8A24.5,24.5,0,0,1,23.3,30a3.2,3.2,0,0,0,.5-4.4h-.2c-3.2-1.9-6,1.2-7.6,2.9l-.6.7c-.9.9-4.4,2.5-5.7,3a.8.8,0,0,0-.4,1.1.8.8,0,0,0,1.1.5c.5-.2,4.9-2.1,6.2-3.3l.7-.8c1.7-1.9,3.5-3.6,5.3-2.7a1.9,1.9,0,0,1-.5,2.1,19.4,19.4,0,0,0-4.2,5.8c-.8,1.7-3.6,3.9-6.3,5a3.6,3.6,0,0,0-2.4,3.2.9.9,0,0,0,.8,1h.1a.8.8,0,0,0,.8-.7c.3-1.6,1-1.6,1-1.6l.3-.2a12.7,12.7,0,0,0,2.3-1.2h.1l12.9,4.6L41.1,7.2Zm5,6.3c-.5,1.4-1.4,1.8-2.6,1.4L23,7.3l-.4,1.2-1.3-.4L23.1,3l1.2.5v.3h0a1.5,1.5,0,0,1,1.3,0,1.8,1.8,0,0,1,.9.8,2.3,2.3,0,0,1-.1,1.6Zm2.1,3V9h0a1.6,1.6,0,0,1-1.2.1l-.8-.6a1.7,1.7,0,0,1,0-1,1,1,0,0,1,.7-.7,2,2,0,0,1,1.1,0l.8.2V6.7a.7.7,0,0,0-.1-.5c0-.1-.2-.2-.5-.3l-1.1-.2.3-.9,1.6.3a3.5,3.5,0,0,1,1.1.7,1.1,1.1,0,0,1,0,1.1l-.9,2.8Zm5.2.5c-.3.8-1,1.1-2.2.7a2.8,2.8,0,0,1-1.2-.8l.3-.8a3.9,3.9,0,0,0,1.1.6c.4.1.7.1.7-.1s.1-.2,0-.2L32,8.9h-.4A1.3,1.3,0,0,1,31,7.2c.2-.4.4-.7.8-.8a2,2,0,0,1,1.3.1l1.2.6-.4.9a2.1,2.1,0,0,0-1-.6c-.3-.1-.6-.1-.6.1a.2.2,0,0,0,0,.3l.3.2.4.2.6.6A1.7,1.7,0,0,1,33.6,9.8ZM35.9,9l.3.3h.3a1.2,1.2,0,0,1,.7.7,1.4,1.4,0,0,1,0,.9c-.4.9-1.1,1.1-2.2.7a3.2,3.2,0,0,1-1.3-.7l.3-.9,1.1.7c.5.1.7.1.8-.1v-.3l-.4-.2-.3-.2a1.2,1.2,0,0,1-.6-1.6,1,1,0,0,1,.7-.7,1.5,1.5,0,0,1,1.3.1,2,2,0,0,1,1.2.6l-.3.8-1-.5c-.4-.1-.6-.1-.7.1S35.8,9,35.9,9Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(18.5 21.2) rotate(19.5)"
  }, "x", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 5.4,
    y: 0
  }, "1"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPass1);
export default __webpack_public_path__ + "static/media/pass1.3d5a393a93c49955eebb4d50f19ea6d9.svg";
export { ForwardRef as ReactComponent };